import React, { useEffect, useState } from "react";
import BundlesSection from "../components/BundlesSection";
import EmailCapture from "../components/EmailCapture";
import { fetchBundles, formatPrice } from "../lib/api";
import { useCart } from "../context/CartContext";
import { toast } from "sonner";
import useSeo from "../hooks/useSeo";

const BundlesPage = () => {
  const [bundles, setBundles] = useState([]);
  const { addItem } = useCart();

  useSeo({
    title: "Grip Sock Bundles · Save up to £15",
    description:
      "Three Pritch grip sock bundles built for matchday, training and rotation — Starter Pair, Matchday Rotation Pack (3 pairs) and Full Colour Pack (5 pairs).",
    path: "/bundles",
  });

  useEffect(() => {
    fetchBundles().then(setBundles).catch(() => {});
  }, []);

  const onAdd = (b) => {
    addItem({
      type: "bundle",
      slug: b.slug,
      name: b.name,
      colourwayLabel: `${b.pairs} pair${b.pairs > 1 ? "s" : ""}`,
      swatch: "#F5F4F0",
      price: b.price,
      image: b.image,
    });
    toast.success(`${b.name} added to cart`);
  };

  return (
    <div data-testid="bundles-page">
      <section className="border-b border-line bg-chalk">
        <div className="container-x py-16 md:py-24">
          <p className="overline mb-4">Bundles</p>
          <h1 className="font-display uppercase text-5xl md:text-7xl tracking-tightest font-bold leading-[0.95]">
            Built for the
            <br />
            <span className="text-mute">rotation.</span>
          </h1>
          <p className="mt-6 max-w-xl text-mute leading-relaxed">
            Match, train, recover, repeat. Packs designed for the way footballers actually wear
            their kit across a season.
          </p>
        </div>
      </section>

      <BundlesSection bundles={bundles} />

      <section className="container-x py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-line border border-line">
          {bundles.map((b) => (
            <div key={b.slug} id={b.slug} className="bg-white p-8 flex flex-col" data-testid={`bundle-page-${b.slug}`}>
              <p className="mono text-xs text-mute">{b.pairs} pair{b.pairs > 1 ? "s" : ""}</p>
              <h3 className="font-display uppercase text-2xl tracking-tightest font-bold mt-3 leading-[1]">{b.name}</h3>
              <p className="text-sm text-mute mt-3 flex-1">{b.description}</p>
              <div className="mt-6 flex items-center justify-between border-t border-line pt-4">
                <p className="mono">{formatPrice(b.price)}</p>
                <button
                  type="button"
                  onClick={() => onAdd(b)}
                  className="btn-primary"
                  data-testid={`bundles-page-add-${b.slug}`}
                >
                  Add to cart
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      <EmailCapture />
    </div>
  );
};

export default BundlesPage;
